import { ConfigProvider } from "antd";
import { ReactNode } from "react";

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          // Button: {
          //   colorPrimary: variables.primaryColor,
          //   colorPrimaryHover: variables.darkColor,
          //   colorBorder: variables.grayColor,
          //   colorPrimaryActive: variables.darkColor,
          // },
          // Checkbox: {
          //   colorPrimary: variables.primaryColor,
          //   colorPrimaryHover: variables.primaryColor,
          //   colorPrimaryActive: variables.primaryColor,
          //   colorBorder: variables.primaryColor,
          // },
          Input: {
            controlOutline: "none",
            controlHeight: 40,
            colorBgContainer: "transparent",
          },
        },
        token: {
          colorPrimary: "#323338",
          // colorSuccess: variables.successColor,
          // colorError: variables.dangerColor,
          // colorWarning: variables.warningColor,
          // fontFamily: "Roboto",

          // Breakpoints for Row/Col, following tailwind css breakpoints https://tailwindcss.com/docs/screens

          // 'sm': '640px',
          // => @media (min-width: 640px) { ... }

          // 'md': '768px',
          // => @media (min-width: 768px) { ... }

          // 'lg': '1024px',
          // => @media (min-width: 1024px) { ... }

          // 'xl': '1280px',
          // => @media (min-width: 1280px) { ... }

          // '2xl': '1536px',
          // => @media (min-width: 1536px) { ... }

          screenSM: 640,
          screenSMMin: 640,
          screenSMMax: 640,

          screenMD: 768,
          screenMDMin: 768,
          screenMDMax: 768,

          screenLG: 1024,
          screenLGMin: 1024,
          screenLGMax: 1024,

          screenXL: 1280,
          screenXLMin: 1280,
          screenXLMax: 1280,

          screenXXL: 1536,
          screenXXLMin: 1536,
        },
      }}
      wave={{
        disabled: true,
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default ThemeProvider;
